import { render, staticRenderFns } from "./BossFishSelectModal.vue?vue&type=template&id=3208621a&"
import script from "./BossFishSelectModal.vue?vue&type=script&lang=ts&"
export * from "./BossFishSelectModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports